// Could we make a generalPaths and typecheck the routes against that?
import { routeTag as r } from './routeTag'

// Used for navigation favourite keys
// Has all the possible options for route parameters
export const createFavouriteKey = (
  routeGenerator: (params: {
    tenantId: string
    ownerId: string
    companyId: string
    policyKey: string
    invoiceId: string
    employerId: string
    employmentId: string
    tradeCycleId: string
    isinKey: string
    employerAgreementId: string
  }) => string,
) =>
  routeGenerator({
    tenantId: ':tenantId',
    ownerId: ':ownerId',
    companyId: ':companyId',
    policyKey: ':policyKey',
    invoiceId: ':invoiceId',
    employerId: ':employerId',
    employmentId: ':employmentId',
    tradeCycleId: ':tradeCycleId',
    isinKey: ':isinKey',
    employerAgreementId: ':employerAgreementId',
  })

export const generalRouteBases = {
  participant: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
    r`/tenant/${tenantId}/participant/${ownerId}`,
  person: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
    r`/tenant/${tenantId}/person/${ownerId}`,
  company: ({ tenantId, companyId }: { tenantId: string; companyId: string }) =>
    r`/tenant/${tenantId}/company/${companyId}`,
}

export const generalRoutes = {
  tenant: {
    home: ({ tenantId }: { tenantId: string }) => r`/tenant/${tenantId}`,
    moneyInMatch: ({ tenantId }: { tenantId: string }) =>
      r`/tenant/${tenantId}/moneyIn/match`,
    moneyInPayments: ({ tenantId }: { tenantId: string }) =>
      r`/tenant/${tenantId}/moneyIn/payments`,
    tradeCycles: ({ tenantId }: { tenantId: string }) =>
      r`/tenant/${tenantId}/trade-cycles`,
    tradeCycle: ({
      tenantId,
      tradeCycleId,
    }: {
      tenantId: string
      tradeCycleId: string
    }) => r`/tenant/${tenantId}/trade-cycles/${tradeCycleId}`,
    funds: ({ tenantId }: { tenantId: string }) => r`/tenant/${tenantId}/funds`,
    fundsSpecific: ({
      tenantId,
      isinKey,
    }: {
      tenantId: string
      isinKey: string
    }) => r`/tenant/${tenantId}/funds/${isinKey}`,
    fund: ({ tenantId, isinKey }: { tenantId: string; isinKey: string }) =>
      r`/tenant/${tenantId}/fund/${isinKey}`,
    search: ({ tenantId }: { tenantId: string }) =>
      r`/tenant/${tenantId}/search`,
  },
  annotation: {
    search: ({ tenantId }: { tenantId: string }) =>
      r`/tenant/${tenantId}/annotation/search`,
    person: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/annotation/person/${ownerId}`,
    company: ({
      tenantId,
      companyId,
    }: {
      tenantId: string
      companyId: string
    }) => r`/tenant/${tenantId}/annotation/company/${companyId}`,
  },
  collective: {
    collCalc: ({ tenantId }: { tenantId: string }) =>
      r`/tenant/${tenantId}/collective/collcalc`,
  },
  commitment: {
    home: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/home`,
    workbench: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/workbench`,
    covers: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/covers`,
    workbenchPoliciesTab: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/workbench?policyTab=policies`,
    policy: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/policy`,
    policyWithKey: ({
      tenantId,
      ownerId,
      policyKey,
    }: {
      tenantId: string
      ownerId: string
      policyKey: string
    }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/policy/${policyKey}`,
    /**
     * @deprecated use policy pages instead, this had no extra information
     */
    cover: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/cover`,
    relatedCommitments: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/relatedCommitments`,
    events: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/events`,
    portfolio: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/portfolio`,
    employments: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) => r`/tenant/${tenantId}/participant/${ownerId}/commitment/employments`,
    paymentsIn: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) => r`/tenant/${tenantId}/participant/${ownerId}/commitment/payments-in`,
    paymentsOut: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) => r`/tenant/${tenantId}/participant/${ownerId}/commitment/payments-out`,
    health: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/health`,
    moneyInInvoices: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/moneyin/invoices`,
    moneyInInvoice: ({
      tenantId,
      ownerId,
      invoiceId,
    }: {
      tenantId: string
      ownerId: string
      invoiceId: string
    }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/moneyin/invoice/${invoiceId}`,
    moneyInEmployments: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/moneyin/employment`,
    moneyInEmployment: ({
      tenantId,
      ownerId,
      employerId,
      employmentId,
    }: {
      tenantId: string
      ownerId: string
      employerId: string
      employmentId: string
    }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/moneyin/employment/${employerId}/${employmentId}`,
    scenarios: ({ tenantId, ownerId }: { tenantId: string; ownerId: string }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/scenarios`,
    paymentReceiver: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) =>
      r`/tenant/${tenantId}/participant/${ownerId}/commitment/moneyout/paymentReceiver`,
  },
  agreement: {
    detail: ({
      tenantId,
      employerAgreementId,
    }: {
      tenantId: string
      employerAgreementId: string
    }) => r`/tenant/${tenantId}/agreement/${employerAgreementId}`,
  },
  company: {
    home: ({ tenantId, companyId }: { tenantId: string; companyId: string }) =>
      r`/tenant/${tenantId}/company/${companyId}/home`,
    legalentity: ({
      tenantId,
      companyId,
    }: {
      tenantId: string
      companyId: string
    }) => r`/tenant/${tenantId}/company/${companyId}/legalentity`,
    agreement: ({
      tenantId,
      companyId,
      employerAgreementId,
    }: {
      tenantId: string
      companyId: string
      employerAgreementId: string
    }) =>
      r`/tenant/${tenantId}/company/${companyId}/agreement/${employerAgreementId}`,
    agreements: ({
      tenantId,
      companyId,
    }: {
      tenantId: string
      companyId: string
    }) => r`/tenant/${tenantId}/company/${companyId}/agreement`,
    moneyInInvoices: ({
      tenantId,
      companyId,
    }: {
      tenantId: string
      companyId: string
    }) => r`/tenant/${tenantId}/company/${companyId}/moneyin/invoices`,
    moneyInInvoice: ({
      tenantId,
      companyId,
      invoiceId,
    }: {
      tenantId: string
      companyId: string
      invoiceId: string
    }) =>
      r`/tenant/${tenantId}/company/${companyId}/moneyin/invoice/${invoiceId}`,
    paymentReceiver: ({
      tenantId,
      companyId,
    }: {
      tenantId: string
      companyId: string
    }) => r`/tenant/${tenantId}/company/${companyId}/moneyout/paymentReceiver`,
  },
  person: {
    legalEntity: ({
      tenantId,
      ownerId,
    }: {
      tenantId: string
      ownerId: string
    }) => r`/tenant/${tenantId}/person/${ownerId}/legalEntity`,
  },
  error: {
    notFound: ({ tenantId }: { tenantId: string }) =>
      r`/tenant/${tenantId}/notFound`,
  },
}
